import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PayeeCasesService } from '../payee-cases.service';
import { products } from '../types';

@Component({
  selector: 'payee-case-product-filter',
  templateUrl: './case-product-filter.component.html',
  styleUrls: ['./case-product-filter.component.scss']
})
export class CaseProductFilterComponent implements OnInit, OnDestroy {
  private readonly destroy = new Subject<void>();
  readonly productControl = new FormControl();

  dropdownOpen = false;

  readonly productOptions = products;

  get product() { return this.payeeCasesService.product.value; }

  constructor(
    private translate: TranslateService,
    private payeeCasesService: PayeeCasesService,
  ) { }

  ngOnInit(): void {
    this.payeeCasesService.product
      .pipe(takeUntil(this.destroy))
      .subscribe(v => this.productControl.patchValue(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  readonly displayWith = (product?: string): string => {
    if (!product) {
      return '';
    }

    return this.translate.instant(`CASES_TABLE.FILTERS.PRODUCT.${product.toUpperCase()}`);
  };

  applyFilter(): void {
    this.payeeCasesService.product.next(this.productControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.payeeCasesService.product.next(null);
    this.dropdownOpen = false;
  }
}